<span
  class="inline-block rounded-full"
  [ngClass]="{
    'bg-yellow-50 text-yellow': type === 'info',
    'bg-blue-50 text-blue-600': type === 'notice',
    'bg-orange-50 text-orange': type === 'warning',
    'bg-green-50 text-green-600': type === 'success',
    'bg-red-50 text-red-600': type === 'error',
    'px-2 py-1 text-xs font-medium': size === 'small',
    'px-3 py-1.5 text-sm': size === 'default',
    'px-4 py-2 text-2xl': size === 'large',
  }"
>
  <ng-content />
</span>
